import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ["subscribeButton", "continueTrialText"]

  connect() {
    this.updateButtonState();
    // Listen for plan selection changes
    document.querySelectorAll('input[name="plan"]').forEach(radio => {
      radio.addEventListener('change', () => this.updateButtonState());
    });
  }

  updateButtonState() {
    const selectedPlan = document.querySelector('input[name="plan"]:checked');
    const subscribeButton = this.subscribeButtonTarget;
    const continueTrialText = this.hasContinueTrialTextTarget ? this.continueTrialTextTarget : null;
    
    if (selectedPlan) {
      subscribeButton.removeAttribute('disabled');
      subscribeButton.classList.remove('opacity-50', 'cursor-not-allowed');
      // Set dynamic continue trial text if present
      if (continueTrialText) {
        // Find the plan name from the card using the target attribute
        const planCard = selectedPlan.closest('[data-plan-selection-target="planCard"]');
        const planNameElem = planCard ? planCard.querySelector('[data-plan-selection-target="planName"]') : null;
        const planName = planNameElem ? planNameElem.textContent.trim() : null;
        if (planName) {
          continueTrialText.textContent = `Continue with ${planName}`;
        }
      }
    } else {
      subscribeButton.setAttribute('disabled', '');
      subscribeButton.classList.add('opacity-50', 'cursor-not-allowed');
      if (continueTrialText) {
        // Fallback to default text
        continueTrialText.textContent = 'Continue Trial';
      }
    }
  }
} 